import {Checkbox} from '@mantine/core';
import classes from './checkbox.module.css';

export const CheckboxTheme = Checkbox.extend({
  classNames: {
    input: classes.input,
  },
});